<kui-modal #modal
    [title]="data.heading || 'DIALOG.INFORMATION' | translate"
    [actions]="modalActions"
    (onClose)="detachModal()">
    <div class="p-4">
        <markdown [data]="data.message"></markdown>
    </div>
</kui-modal>